import { Icon20ArrowLeftOutline } from '@vkontakte/icons';
import React, { type FC, type MouseEvent } from 'react';
import { MenuButton } from 'reactApp/ui/ReactViewer/ViewerMenu/MenuButton/MenuButton';

import styles from './ReturnMenuButton.css';

interface Props {
    onClick?: (evt: MouseEvent) => void;
}

export const ReturnMenuButton: FC<Props> = ({ onClick }) => {
    return <MenuButton className={styles.button} hint="Вернуться" icon={<Icon20ArrowLeftOutline />} onClick={onClick} />;
};
